import { useTranslation } from "next-i18next";
import { vehicleValidation } from "@talladega/helpers";
import { FieldValues } from "react-hook-form";
import { FormInputProps } from "@talladega/types";
import { Form } from ".";

type Props<T extends FieldValues> = {
  required?: boolean;
} & FormInputProps<T>;

export const ModelInput = <TFormValues extends FieldValues>({
  name,
  register,
  errors,
  required = false,
  ...props
}: Props<TFormValues>): JSX.Element => {
  const { t } = useTranslation(["common"]);

  const error = name ? errors?.[name] : undefined;

  return (
    <Form.Input
      id="model"
      label={t("common:model") || undefined}
      feedback={error?.message?.toString()}
      status={error ? "error" : "default"}
      maxLength={vehicleValidation.model.maxLength}
      {...(register &&
        name &&
        register(name, {
          required: {
            value: required,
            message: t("common:required"),
          },
          maxLength: {
            value: vehicleValidation.model.maxLength,
            message: t("common:invalid_model"),
          },
        }))}
      {...props}
    />
  );
};

export default {};
